import React, {Component} from 'react';
import { Button } from 'carbon-components-react';
import PropertyComponent from './PropertyComponent';
import * as midi from '../js/rpl_midi.js';

// calls setDeviceProperty with specified dataBytes on click
class DevicePropertyButton extends React.Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);

		this.kind      = props.kind;
		this.propId    = props.propId;
		this.dataBytes = props.dataBytes;
		this.refresh   = props.refreshProps;
	}

	handleClick(event) {
		midi.setDeviceProperty(this.propId, this.dataBytes);
		if (this.refresh == true) {
			midi.updateAllPropertyValues();
		}
	}

	render() {
		return (
			<Button kind={this.kind} onClick={this.handleClick}>{this.props.children}</Button>
		);
	}
}

export default DevicePropertyButton;
